import React from "react";
import { FormattedMessageWithClass } from "../index";
import Proptypes from "prop-types";
import './button.scss';

const Button = ({
  className = "btn btn-primary",
  classNameValue = "",
  classNameHeading = "",
  disabled,
  onClick,
  value,
  heading,
  defaultMessage,
  defaultMessageHeading,
  classNameSubHeading = "",
  defaultMessageSubHeading,
  classNameSubHeadingEnabled,
}) => {
  return (
    <button className={className} disabled={disabled} onClick={onClick}>
      <FormattedMessageWithClass
        className={classNameValue}
        id={value}
        defaultMessage={defaultMessage}
      />
      {heading && (
        <FormattedMessageWithClass
          className={classNameHeading}
          id={heading}
          defaultMessage={defaultMessageHeading}
        />
      )}
      {classNameSubHeadingEnabled && (
        <FormattedMessageWithClass
          className={classNameSubHeading}
          id={classNameSubHeadingEnabled}
          defaultMessage={defaultMessageSubHeading}
        />
      )}
    </button>
  );
};
export default Button;

Button.propTypes = {
  className: Proptypes.string.isRequired,
  classNameValue: Proptypes.string.isRequired,
  classNameHeading: Proptypes.string,
  disabled: Proptypes.bool,
  onClick: Proptypes.func.isRequired,
  value: Proptypes.string.isRequired,
  heading: Proptypes.string,
  defaultMessage: Proptypes.string.isRequired,
  defaultMessageHeading: Proptypes.string,
  classNameSubHeading: Proptypes.string,
  defaultMessageSubHeading: Proptypes.string,
  classNameSubHeadingEnabled: Proptypes.string,
};
